<template>
  <div>
    <qd-button
      :class="[
        classButton,
        'mgr-0',
        {
          'double-sticky-button-right': actions.length,
          'button-access-no-permission pointer-events-none': disabled,
        }
      ]"
      :type="type"
      @click="checkAllPermissions(permission) ? $emit('click') : showPopUp">
        <slot />
    </qd-button>
    <b-dropdown
        v-if="actions.length > 0"
        class="is-relative"
        :class="{'pointer-events-none': disabled}"
        aria-role="list"
        :position="position">
      <template #trigger>
        <qd-button
          :class="[
            classButton,
            'mgv-0 double-sticky-button-left',
            {
              'double-sticky-button-right': actions.length,
              'button-access-no-permission pointer-events-none': disabled,
            }
          ]"
          :type="type">
          <b-icon class="mgt-1" icon="chevron-down"/>
        </qd-button>
      </template>
      <b-dropdown-item v-for="(item, index) in sortedActions()"
        :key="index"
        aria-role="listitem"
        :disabled="!!item.disabled"
        @click="() => {
          checkAllPermissions(item.permissionAction) ? item.action() : showPopUp;
        }">
        <b-tooltip
          :active="!!item.disabled && !!item.tooltip"
          :label="item.tooltip"
          type="is-primary"
          position="is-left">
          <span>{{item.label}}</span>
        </b-tooltip>
      </b-dropdown-item>
    </b-dropdown>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';

const permissions = createNamespacedHelpers('permissions');

export default {
  props: {
    type: {
      type: String,
      required: false,
      default: '',
    },
    position: {
      type: String,
      required: false,
      default: 'is-bottom-left',
    },
    classButton: {
      type: String,
      required: false,
      default: '',
    },
    actions: {
      type: Array,
      required: false,
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    permission: {
      type: Object,
      required: false,
      default: () => {},
    },
  },
  computed: {
    ...permissions.mapGetters({
      checkPermissions: 'checkPermissions',
    }),
    ...permissions.mapActions({
      showPopUp: 'showPopup',
    }),
  },
  methods: {
    sortedActions() {
      if (this.actions && this.actions.length >= 2) {
        this.actions.sort((a, b) => a.order - b.order);
      }
      return this.actions;
    },
    checkAllPermissions(permissions) {
      if (permissions) {
        return this.checkPermissions(permissions);
      }
      if (this.permission) {
        return this.checkPermissions(this.permission);
      }
      return true;
    },
  },
};
</script>

<style>

</style>
